<template>
    <div class="sidebar-logo-container" :class="{'collapse':collapse}">
        <transition name="sidebarLogoFade">
            <router-link v-if="collapse" key="collapse" class="sidebar-logo-link" to="/">
                <img v-if="logo" :src="logo" class="sidebar-logo">
            </router-link>
            <router-link v-else key="expand" class="sidebar-logo-link" to="/">
                <img v-if="logo" :src="logo" class="sidebar-logo">
                <h1 class="sidebar-title">{{ title }} </h1>
            </router-link>
        </transition>
    </div>
</template>

<script>
export default {
    name: "SidebarLogo",
    props: {
        collapse: {
            type: Boolean,
            required: true
        }
    },
    data() {
        return {
            title: "服 务 云",
            logo: require("@/assets/pictures/cloud-02.png"),
            isCollapse: true
        };
    }
};
</script>

<style lang="scss" scoped>
.sidebarLogoFade-enter-active {
    transition: opacity 1.5s;
}

.sidebarLogoFade-enter,
.sidebarLogoFade-leave-to {
    opacity: 0;
}

.sidebar-logo-container {
    position: relative;
    width: 100%;
    height: 50px;
    text-align: center;
    overflow: hidden;
    .sidebar-logo-link {
        height: 100%;
        width: 100%;
        padding-top: 8px;
        white-space: nowrap;
        .sidebar-logo {
            margin-right: 30px;
            width: 55px;
            height: 34px;
            vertical-align: bottom;
        }
        .sidebar-title {
            display: inline-block;
            margin: 0;
            color: #fff;
            font-weight: normal;
            font-size: 20px;
            font-family: Avenir, Helvetica Neue, Arial, Helvetica, sans-serif;
            vertical-align: bottom;
        }
    }

    &.collapse {
        .sidebar-logo {
            width: 40px;
            padding-top: 6px;
            margin-right: 0px;
        }
        .sidebar-title {
            line-height: 25px;
        }
    }
}
</style>
